import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';
import $ from 'jquery';

@Component({
  selector: 'app-xero-integration',
  templateUrl: './xero-integration.component.html',
  styleUrls: ['./xero-integration.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XeroIntegrationComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  isLoadingResults: boolean = false;
  @Input() errorWarningData: any;
  hide: boolean = true;
  NETACCOUNTS: any[] = [];
  tenantName: string;
  tenant: any;
  sub: Subscription;
  sub1: Subscription;
  isspinerInfo: boolean = false;
  isLoading: boolean = false;
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  private _unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    private behaviorService: BehaviorService,
    public datepipe: DatePipe,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingSystemSetting('xero');
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to test the Connactions.
   */
  testConnections(): void {
    let currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    let payload: any = {
      Action: 'OAuth2Start',
      VALIDATEONLY: false,
      Data: {
        USERGUID: currentUser.UserGuid,
        AuthType: 'NetAccounts',
      },
    };
    this._mainAPiServiceService
      .getSetData(payload, 'oauth-connections')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            window.open(
              response.DATA[0].AuthorizationUrl,
              'targetWindow',
              `toolbar=no,
                        location=no,
                        status=no,
                        menubar=no,
                        scrollbars=yes,
                        resizable=yes,
                        width=800,
                        height=600,
                        noopener,noreferrer`,
            );
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to choose Xero Date.
   */
  chooseXeroDate(type: string, event: MatDatepickerInputEvent<Date>): void {
    this.SettingForm.controls['XEROSTARTDATE'].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
    this.cd.markForCheck();
  }

  /**
   * This function is used to change Tenant data value.
   */
  changeTenant(event: any): void {
    this.tenant = this.NETACCOUNTS.filter((tenant) => tenant.TENANTID === event.value);
    this.cd.markForCheck();
  }

  /**
   * This function is used to load the Org
   */
  loadOrg(): void {
    this.isLoadingResults = true;
    this.cd.markForCheck();
    let Data: any = { Action: 'GetData', FILTERS: { DATASET: 'Tenants' } };
    this.sub = this._mainAPiServiceService
      .getSetData(Data, 'NetAccounts')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            this.NETACCOUNTS = response.DATA.TENANTS;
          }
          this.isLoadingResults = false;
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isLoadingResults = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to linkOrg data value.
   */
  linkOrg(): void {
    if (this.tenant && this.tenant.length > 0) {
      this.isLoadingResults = true;
      this.cd.markForCheck();
      let Data: any = {
        Action: 'linkorganisation',
        DATA: {
          ORGANISATIONID: this.tenant[0].TENANTID,
          ORGANISATIONNAME: this.tenant[0].TENANTNAME,
        },
      };
      this.sub1 = this._mainAPiServiceService
        .getSetData(Data, 'NetAccounts')
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (response: any) => {
            if (response.CODE == 200 && response.STATUS == 'success') {
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
            this.isLoadingResults = false;
            this.cd.markForCheck();
          },
          error: (error: any) => {
            this.isLoadingResults = false;
            this.toastr.error(error);
            this.cd.markForCheck();
          },
        });
    }
  }

  /**
   * This function is used to Connect To XERO
   */
  ConnectToXero(): void {
    let payload: any = {
      Action: 'OAuth2Start',
      VALIDATEONLY: false,
      Data: {
        USERGUID: this.currentUser.UserGuid,
        AuthType: 'Xero',
      },
    };
    this._mainAPiServiceService
      .getSetData(payload, 'oauth-connections')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            window.open(
              response.DATA[0].AuthorizationUrl,
              'targetWindow',
              `toolbar=no,
                        location=no,
                        status=no,
                        menubar=no,
                        scrollbars=yes,
                        resizable=yes,
                        width=800,
                        height=600,
                        noopener,noreferrer`,
            );
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the xero integration data
   */
  saveXero() {
    this.isspinerInfo = true;
    this.cd.markForCheck();
    let data: any = {
      GroupName: 'Integrations',
      SubgroupName: 'Xero',
      XEROINVOICEACCOUNT: this.SettingForm.controls['XEROINVOICEACCOUNT'].value,
      XEROSTARTDATE: this.SettingForm.controls['XEROSTARTDATE'].value,
      XERODONTSYNCINVOICES: this.SettingForm.controls['XERODONTSYNCINVOICES'].value,
      XERODONTSYNCEXPENSES: this.SettingForm.controls['XERODONTSYNCEXPENSES'].value,
      XEROORGANISATION: this.SettingForm.controls['XEROORGANISATION'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerInfo = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerInfo = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerInfo = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerInfo = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerInfo = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  disconnectXero() {
    this.isLoading = true;
    this.cd.markForCheck();
    let Data: any = {
      Action: 'disconnect',
      DATA: {
        XEROORGANISATION: this.SettingForm.controls['XEROORGANISATION'].value,
      },
    };
    this._mainAPiServiceService
      .getSetData(Data, 'NetAccounts')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            if (response.MESSAGE) {
              this.toastr.success(response?.MESSAGE);
            }
            $('#refresh_system_data').click();
          } else if (response.CODE == 433 && response.STATUS == 'error') {
            this.toastr.warning(response.MESSAGE);
          }
          this.isLoading = false;
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isLoading = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
}
